import React from "react";
import { Select, SelectItem } from "@/components/vb";
import { useWorkspace } from "@/context/WorkspaceContext";
import { WorkspaceRole } from "@/types/workspace";

/** The one workspace switcher for the settings surface.
 *
 *  Replaces three near-identical copies (workspace panel, billing panel, and a
 *  third variant in the reporting panel). All three already wrote the *global*
 *  active workspace rather than filtering locally, so hoisting it to the shell
 *  changes nothing except how many of them there are. */
export function WorkspaceSwitcher({ className }: { className?: string }) {
    const { activeWorkspace, workspaces, setActiveWorkspace } = useWorkspace();

    if (workspaces.length <= 1) {
        return null;
    }

    return (
        <Select
            value={activeWorkspace ? String(activeWorkspace.id) : undefined}
            onValueChange={(workspaceId) => {
                const workspace = workspaces.find((item) => String(item.id) === workspaceId);
                if (workspace) {
                    setActiveWorkspace(workspace);
                }
            }}
            placeholder="Select workspace"
            aria-label="Select current workspace"
            className={className}
        >
            {workspaces.map((workspace) => (
                <SelectItem key={workspace.id} value={String(workspace.id)}>
                    {workspace.name}
                    {workspace.role !== WorkspaceRole.Owner ? " · Invited" : ""}
                </SelectItem>
            ))}
        </Select>
    );
}

export default WorkspaceSwitcher;
